<div class="table-outer-wrapper" [ngClass]="'table-' + uniqueId" *ngIf="vm">
  <!-- Header: Scrolls horizontally with body, but stays fixed vertically -->
  <div class="header-container" #headerContainer
       [tableColumnManager]="uniqueId"
       [defaultWidths]="defaultWidths"
       [columnGroups]="columnGroups"
       [settings]="settings"
       (settingsChange)="onSettingsChange.emit($event)">
    <div class="table-inner-wrapper">
      <div class="routes-table-list-container">
        <div class="tr sticky-header">
          <!-- Merged header for drag, checkbox, and ID -->
          <div class="th col-id sticky-col" translate>
            Route
            <app-table-column-insert-button></app-table-column-insert-button>
          </div>

          @if (settings?.columns?.id) {
            <div class="th col-route-id" translate>
              ID
              <app-table-column-insert-button column="id"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.status) {
            <div class="th col-status" translate>
              Status
              <app-table-column-insert-button column="status"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.agent) {
            <div class="th col-agent" translate>
              Agent
              <app-table-column-insert-button column="agent"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.vehicle) {
            <div class="th col-vehicle" translate>
              Vehicle
              <app-table-column-insert-button column="vehicle"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.timeWindow) {
            <div class="th col-time-window" translate>
              Time Window
              <app-table-column-insert-button column="timeWindow"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.duration) {
            <div class="th col-duration" translate>
              Duration
              <app-table-column-insert-button column="duration"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.distance) {
            <div class="th col-distance" translate>
              Distance
              <app-table-column-insert-button column="distance"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.services) {
            <div class="th col-services" translate>
              Services
              <app-table-column-insert-button column="services"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.tasksCount) {
            <div class="th col-tasks-count" translate>
              Stops
              <app-table-column-insert-button column="tasksCount"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.pickupStops) {
            <div class="th col-pickup-stops" translate>
              Pickups
              <app-table-column-insert-button column="pickupStops"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.destinationStops) {
            <div class="th col-destination-stops" translate>
              Dropoffs
              <app-table-column-insert-button column="destinationStops"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.proNumber) {
            <div class="th col-pro-number" translate>
              Pro Number
              <app-table-column-insert-button column="proNumber"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.relations) {
            <div class="th col-relations" translate>
              Relations
              <app-table-column-insert-button column="relations"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.referenceIds) {
            <div class="th col-reference-ids" translate>
              Reference IDs
              <app-table-column-insert-button column="referenceIds"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.accounts) {
            <div class="th col-accounts" translate>
              Accounts
              <app-table-column-insert-button column="accounts"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.accountsExternalIds) {
            <div class="th col-accounts-external-ids" translate>
              Account Ext IDs
              <app-table-column-insert-button column="accountsExternalIds"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.pickingHour) {
            <div class="th col-picking-hour" translate>
              Picking Hour
              <app-table-column-insert-button column="pickingHour"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.trips) {
            <div class="th col-trips" translate>
              Trips
              <app-table-column-insert-button column="trips"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.skills) {
            <div class="th col-skills" translate>
              Skills
              <app-table-column-insert-button column="skills"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.tags) {
            <div class="th col-tags" translate>
              Tags
              <app-table-column-insert-button column="tags"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.resource) {
            <div class="th col-vehicle" translate>
              Resource
              <app-table-column-insert-button column="resource"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.plateNumber) {
            <div class="th col-plate-number" translate>
              Plate Number
              <app-table-column-insert-button column="plateNumber"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.assistant) {
            <div class="th col-assistant" translate>
              Assistants
              <app-table-column-insert-button column="assistant"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.price) {
            <div class="th col-price" translate>
              Price
              <app-table-column-insert-button column="price"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.value) {
            <div class="th col-value" translate>
              Value
              <app-table-column-insert-button column="value"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.progress) {
            <div class="th col-progress" translate>
              Progress
              <app-table-column-insert-button column="progress"></app-table-column-insert-button>
            </div>
          }

          <!-- Load Columns -->
          @if (settings?.load?.weight) {
            <div class="th col-load col-load-weight" translate>
              Weight
              <app-table-column-insert-button column="weight" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.volume) {
            <div class="th col-load col-load-volume" translate>
              Volume
              <app-table-column-insert-button column="volume" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.packages) {
            <div class="th col-load col-load-packages" translate>
              Packages
              <app-table-column-insert-button column="packages" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.pallets) {
            <div class="th col-load col-load-pallets" translate>
              Pallets
              <app-table-column-insert-button column="pallets" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.spots) {
            <div class="th col-load col-load-spots" translate>
              Spots
              <app-table-column-insert-button column="spots" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.value) {
            <div class="th col-load col-load-value" translate>
              Value
              <app-table-column-insert-button column="value" group="load"></app-table-column-insert-button>
            </div>
          }

          <!-- Capacity Columns -->
          @if (settings?.capacity?.weight) {
            <div class="th col-capacity col-capacity-weight" translate>
              Weight %
              <app-table-column-insert-button column="weight" group="capacity"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.capacity?.volume) {
            <div class="th col-capacity col-capacity-volume" translate>
              Volume %
              <app-table-column-insert-button column="volume" group="capacity"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.capacity?.pallets) {
            <div class="th col-capacity col-capacity-pallets" translate>
              Pallets %
              <app-table-column-insert-button column="pallets" group="capacity"></app-table-column-insert-button>
            </div>
          }

          <ng-container *ngIf="settings?.metadata">
            <ng-container *ngFor="let metaData of settings.metadata">
              <div *ngIf="metaData.enabled" class="th col-meta-data">{{ metaData.title }}</div>
            </ng-container>
          </ng-container>

          <div class="th col-actions sticky-col-right"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- The drop list wraps the empty state as well, so a resource with no routes still accepts drops -->
  <div class="body-container-wrapper"
       cdkDropList
       [id]="panel.id"
       [cdkDropListData]="vm.routes"
       [cdkDropListConnectedTo]="allPanelIds"
       [cdkDropListEnterPredicate]="cdkEnterPredicate"
       (cdkDropListDropped)="onListDrop($event)">

    <div *ngIf="!vm.loading && !vm.routes?.length" class="flex layout-row layout-align-center-center padding-20">
      <app-empty-state src="assets/images/empty_state/empty_state_routes.png" text="No Routes Found"></app-empty-state>
    </div>

    <cdk-virtual-scroll-viewport *ngIf="vm.routes?.length"
                                 class="body-container"
                                 [itemSize]="36"
                                 #bodyContainer
                                 (scroll)="onBodyScroll($event)">

      <div class="table-inner-wrapper">
        <div class="routes-table-list-container">
          <ng-container>
            <app-routes-table-list-row *cdkVirtualFor="let route of vm.routes; trackBy: trackById"
                             [route]="route"
                             [settings]="settings"
                             [isSelected]="selectedKeys[route.id]"
                             [isVisible]="visibleKeys[route.id]"
                             [isResourceView]="isResourceView"
                             [excludeMode]="excludeMode"
                             [allPanelIds]="allPanelIds"
                             [panelId]="panel.id"
                             [isSummaryRow]="false"
                             (onToggleSelected)="onToggleSelectedRoute($event.route, $event.isSelected)"
                             (onToggleVisible)="onToggleVisible.emit({route: $event.route, isVisible: $event.isVisible})"
                             (onToggleLocked)="onToggleLocked($event)"
                             (onSelectRouteResource)="onSelectRouteResource.emit({route: $event.route, event: $event.event})"
                             (onRowClick)="onRowClick($event.route, $event.event)"
                             (onRowDoubleClick)="onDrillDownDblClick($event.route, $event.event)"
                             (onDrop)="onDrop($event.route, $event.event)"
                             (onDrillDownClick)="onDrillDownClick($event.route, $event.event)">
            </app-routes-table-list-row>
          </ng-container>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>

  </div>

  <app-bringoz-linear-progress *ngIf="vm.loading"></app-bringoz-linear-progress>

  <ng-template #emptyLoad>
    <span class="br-body-1">---</span>
  </ng-template>
</div>
